import { CgArrowLongRight } from 'react-icons/cg';
import { FaCheck } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const HomeAbout = () => {
   return (
      <>
         <section className="about__area pb-200 pt-100">
            <div className="container">
               <div className="row">
                  <div className="col-xl-6 pr-0 col-lg-6">
                     <div className="about__thumb m-img">
                        <img src="assets/img/about/about-1.jpg" alt=""/>
                           <div className="about__shape">
                              <img src="assets/img/about/red-shape.png" alt=""/>
                           </div>
                     </div>
                  </div>
                  <div className="col-xl-5 offset-xl-1 col-lg-5 offset-lg-1">
                     <div className="about__content">
                        <div className="section__title mb-25">
                           <span>Quiénes Somos</span>
                           <h2>Promesas: Guardianes de la Esperanza</h2>
                        </div>
                        <p>En la fundación Promesas, creemos en el poder transformador del apoyo y la justicia. Nos dedicamos a reconstruir vidas y restaurar la alegría en los corazones de los menores afectados por el abuso sexual. Trabajamos incansablemente para ser un faro de esperanza y guía.</p>
                        <div className="about__list">
                           <ul>
                              <li ><span><i > <FaCheck/> </i>Compromiso Incansable</span></li>
                              <li ><span><i > <FaCheck/> </i>Recuperación y Dignidad</span></li>
                              <li ><span><i > <FaCheck/> </i>Defensa y Protección</span></li>
                           </ul>
                        </div>
                        <Link to="/services" className="z-btn " >Descubre Nuestro Compromiso<i > <CgArrowLongRight /> </i></Link>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeAbout;